// extracted by mini-css-extract-plugin
export var container = "Banner-module_container__23PFy";
export var desktop = "Banner-module_desktop__3lLV7";
export var logo = "Banner-module_logo__2yrO6";
export var textWrapper = "Banner-module_textWrapper__2MWYQ";
export var text = "Banner-module_text__2--oy";